import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import { DateTime } from 'luxon';
import getSentimentIcon from '../SentimentIcons/getSentimentIcon';
import { getEventStartSeconds } from '../util';

const EventMarkerContainer = styled('div')({
    position: 'absolute',
    top: 0,
    backgroundColor: '#243B53',
    padding: '6px 4px',
    marginLeft: -15,
    borderRadius: 2,
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    '& svg': {
        height: 20
    }
});

const EventMarker = (props) => {
    const { event, visicamStartDate, videoDuration } = props;
    const eventData = JSON.parse(event.data);
    const startSeconds = getEventStartSeconds(event, visicamStartDate);

    // Protect against negative durations (this would include comments added before the session started).
    if (isNaN(startSeconds)) {
        return null;
    }

    const start = (1 / videoDuration) * startSeconds;

    return (
        <EventMarkerContainer
            onClick={props.onClick}
            key={event.id}
            style={{
                left: `${start * 100}%`
            }}
        >
            { getSentimentIcon(eventData.Sentiment) }

            <div
                style={{
                    position: 'absolute',
                    bottom: -4,
                    left: '50%',
                    marginLeft: -4,
                    width: 0,
                    height: 0,
                    borderLeft: '4px solid transparent',
                    borderRight: '4px solid transparent',
                    borderTop: '4px solid #243B53'
                }}
            />
        </EventMarkerContainer>
    );
};

EventMarker.propTypes = {
    event: PropTypes.object,
    onClick: PropTypes.func,
    videoDuration: PropTypes.number,
    visicamStartDate: PropTypes.instanceOf(DateTime)
};

export default EventMarker;
